import { c as _c } from "react/compiler-runtime";
import clsx from "clsx";
import type { CSSProperties, ReactNode } from "react";
import type { TokenMetadata } from "@/components/nft-picker/NftPicker.types";
import type { TokenListAction, TokenWindowEntry } from "../types";
import { TokenThumbnail } from "./TokenThumbnail";
type TokenRowProps = Readonly<{
  token: TokenWindowEntry;
  metadata?: TokenMetadata | undefined;
  rowClassName?: string | undefined;
  renderTokenExtra?: ((tokenId: bigint, metadata?: TokenMetadata) => ReactNode) | undefined | undefined;
  action?: TokenListAction | undefined;
  isMetadataLoading: boolean;
  hasMetadataError: boolean;
  positionStyle: CSSProperties;
}>;
export function TokenRow(t0) {
  const $ = _c(32);
  const {
    token,
    metadata,
    rowClassName,
    renderTokenExtra,
    action,
    isMetadataLoading,
    hasMetadataError,
    positionStyle
  } = t0;
  let t1;
  if ($[0] !== rowClassName) {
    t1 = clsx("tw-absolute tw-flex tw-w-full tw-items-center tw-gap-3 tw-px-3 tw-py-2", rowClassName);
    $[0] = rowClassName;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  let t2;
  if ($[2] !== hasMetadataError || $[3] !== isMetadataLoading || $[4] !== metadata || $[5] !== token.decimalId) {
    t2 = <div className="tw-h-10 tw-w-10"><TokenThumbnail metadata={metadata} decimalId={token.decimalId} isLoading={isMetadataLoading} hasError={hasMetadataError} /></div>;
    $[2] = hasMetadataError;
    $[3] = isMetadataLoading;
    $[4] = metadata;
    $[5] = token.decimalId;
    $[6] = t2;
  } else {
    t2 = $[6];
  }
  let t3;
  if ($[7] !== token.decimalId) {
    t3 = <span className="tw-text-sm tw-font-medium tw-text-white">#{token.decimalId}</span>;
    $[7] = token.decimalId;
    $[8] = t3;
  } else {
    t3 = $[8];
  }
  let t4;
  if ($[9] !== metadata) {
    t4 = metadata?.name && <span className="tw-text-xs tw-text-iron-400">{metadata.name}</span>;
    $[9] = metadata;
    $[10] = t4;
  } else {
    t4 = $[10];
  }
  let t5;
  if ($[11] !== t3 || $[12] !== t4) {
    t5 = <div className="tw-flex tw-flex-col tw-gap-0.5">{t3}{t4}</div>;
    $[11] = t3;
    $[12] = t4;
    $[13] = t5;
  } else {
    t5 = $[13];
  }
  let t6;
  if ($[14] !== metadata || $[15] !== renderTokenExtra || $[16] !== token.tokenId) {
    t6 = renderTokenExtra?.(token.tokenId, metadata);
    $[14] = metadata;
    $[15] = renderTokenExtra;
    $[16] = token.tokenId;
    $[17] = t6;
  } else {
    t6 = $[17];
  }
  let t7;
  if ($[18] !== action || $[19] !== metadata || $[20] !== token.decimalId || $[21] !== token.tokenId) {
    t7 = action ? <button type="button" className="tw-rounded tw-border tw-border-iron-700 tw-bg-transparent tw-px-2 tw-py-1.5 tw-text-xs tw-text-iron-200 hover:tw-border-primary-500 hover:tw-text-white" onClick={() => action.onClick(token.tokenId, metadata)} aria-label={action.getAriaLabel?.(`#${token.decimalId}`) ?? action.label}>{action.label}</button> : null;
    $[18] = action;
    $[19] = metadata;
    $[20] = token.decimalId;
    $[21] = token.tokenId;
    $[22] = t7;
  } else {
    t7 = $[22];
  }
  let t8;
  if ($[23] !== t5 || $[24] !== t6 || $[25] !== t7) {
    t8 = <div className="tw-flex tw-flex-1 tw-items-center tw-justify-between tw-gap-4">{t5}{t6}{t7}</div>;
    $[23] = t5;
    $[24] = t6;
    $[25] = t7;
    $[26] = t8;
  } else {
    t8 = $[26];
  }
  let t9;
  if ($[27] !== positionStyle || $[28] !== t1 || $[29] !== t2 || $[30] !== t8) {
    t9 = <li className={t1} style={positionStyle}>{t2}{t8}</li>;
    $[27] = positionStyle;
    $[28] = t1;
    $[29] = t2;
    $[30] = t8;
    $[31] = t9;
  } else {
    t9 = $[31];
  }
  return t9;
}